<template>
    <section class="relative md:py-24 py-16 bg-slate-50 dark:bg-slate-800" id="services">
        <div class="container relative">
            <div class="grid grid-cols-1 pb-6 text-center">
                <h3 class="font-semibold text-2xl leading-normal mb-4">{{ $t('features.1') }}</h3>

                <p class="text-slate-400 max-w-xl mx-auto">{{ $t('features.2') }}</p>
            </div><!--end grid-->

            <div class="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-6 mt-6">
                <div v-for="item in servicesData" :key="item.id" class="group rounded-md shadow dark:shadow-gray-700 relative bg-white dark:bg-slate-900 p-6 overflow-hidden h-fit">
                    <div class="flex items-center justify-center size-14 -rotate-45 bg-gradient-to-r from-transparent to-teal-500/10 text-teal-500 text-center rounded-full group-hover:bg-teal-500/10 duration-500">
                        <i :data-feather="item.icon" class="size-6 rotate-45"></i>
                    </div>

                    <div class="content mt-6 relative z-1">
                        <a href="" class="title text-lg font-semibold hover:text-teal-500">{{item.title}}</a>
                        <p class="text-slate-400 mt-3">{{item.desc}}</p>
                    </div>

                    <div class="absolute bottom-0 -end-16">
                        <i :data-feather="item.icon" class="size-48 text-teal-500 opacity-[0.04] dark:opacity-[0.04] group-hover:opacity-10 duration-500"></i>
                    </div>
                </div>
            </div><!--end grid-->
        </div><!--end container-->
    </section>
</template>

<script>
import feather from 'feather-icons';

export default {
    computed: {
        servicesData() {
            return [
                { 
                    id: 1, 
                    icon: 'code', 
                    title: this.$t('features.3'), 
                    desc: this.$t('features.4') 
                },
                { 
                    id: 2, 
                    icon: 'monitor', 
                    title: this.$t('features.5'), 
                    desc: this.$t('features.6') 
                },
                { 
                    id: 3, 
                    icon: 'layers', 
                    title: this.$t('features.7'), 
                    desc: this.$t('features.8') 
                },
                { 
                    id: 4, 
                    icon: 'smartphone', 
                    title: this.$t('features.9'), 
                    desc: this.$t('features.10') 
                },
                { 
                    id: 5, 
                    icon: 'cpu', 
                    title: this.$t('features.11'), 
                    desc: this.$t('features.12') 
                },
                { 
                    id: 6, 
                    icon: 'globe', 
                    title: this.$t('features.13'), 
                    desc: this.$t('features.14') 
                },
                { 
                    id: 7, 
                    icon: 'shuffle', 
                    title: this.$t('features.15'), 
                    desc: this.$t('features.16') 
                },
                { 
                    id: 8, 
                    icon: 'settings', 
                    title: this.$t('features.17'), 
                    desc: this.$t('features.18') 
                },
            ];
        }
    },

    mounted() {
        feather.replace();
    }
};
</script>